import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["query", "grid", "list"]

    connect() {
        this._applySavedLayout()
    }

    _applySavedLayout() {
        const saved = document.documentElement.getAttribute("data-menu-hub-layout") || "cards"
        if (saved === "list") {
            this.setList()
        } else {
            this.setCards()
        }
    }

    setCards(event) {
        if (event) event.stopPropagation()
        this.gridTarget.classList.remove("d-none")
        this.gridTarget.style.setProperty("display", "flex", "important")
        this.listTarget.classList.add("d-none")
        this.listTarget.style.setProperty("display", "none", "important")
        this._setActiveLayout("cards")
        document.documentElement.setAttribute("data-menu-hub-layout", "cards")
    }

    setList(event) {
        if (event) event.stopPropagation()
        this.gridTarget.classList.add("d-none")
        this.gridTarget.style.setProperty("display", "none", "important")
        this.listTarget.classList.remove("d-none")
        this.listTarget.style.setProperty("display", "block", "important")
        this._setActiveLayout("list")
        document.documentElement.setAttribute("data-menu-hub-layout", "list")
    }

    filter() {
        const q = (this.queryTarget.value || "").toLowerCase().trim()

        this.element.querySelectorAll("[data-menu-hub-item]").forEach((el) => {
            const title = (el.dataset.title || "").toLowerCase()
            const desc = (el.dataset.desc || "").toLowerCase()

            const isMatch = title.includes(q) || desc.includes(q)

            if (isMatch) {
                el.classList.remove("d-none")
                el.style.setProperty("display", "", "important")
            } else {
                el.classList.add("d-none")
                el.style.setProperty("display", "none", "important")
            }
        })
    }

    _setActiveLayout(type) {
        const cardsBtn = this.element.querySelector("[data-menu-hub-cards]")
        const listBtn = this.element.querySelector("[data-menu-hub-list]")
        const isCards = type === "cards"

        if (cardsBtn) {
            cardsBtn.className = isCards
                ? "btn btn-dark btn-sm rounded-3 px-3"
                : "btn btn-outline-secondary btn-sm rounded-3 px-3"
        }
        if (listBtn) {
            listBtn.className = !isCards
                ? "btn btn-dark btn-sm rounded-3 px-3"
                : "btn btn-outline-secondary btn-sm rounded-3 px-3"
        }
    }
}